<template>
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-dashboard-menu></coach-dashboard-menu>

    <!-- Page Content -->
    <div class="content court-bg">
        <div class="container">

            <!-- Sort By -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="sortby-section court-sortby-section">
                        <div class="sorting-info">
                            <div class="row d-flex align-items-center">
                                <div class="col-xl-12 col-sm-12 col-auto">
                                    <div class="sortby-filter-group court-sortby">
                                        <div class="sortbyset week-bg">
                                            <div class="sorting-select">
                                                <vue-select 
                                                    :options="Week"
                                                    id="oneday"
                                                    placeholder="This Week"
                                                />
                                            </div>
                                        </div>
                                        <div class="sortbyset">
                                            <span class="sortbytitle">Sort By</span>
                                            <div class="sorting-select">
                                                <vue-select 
                                                    :options="Sort"
                                                    id="priceday"
                                                    placeholder="Relevance"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- Sort By -->

            <div class="row">
                <div class="col-sm-12">
                    <div class="court-tab-content">
                        <div class="card card-tableset">
                            <div class="card-body">
                                <div class="coache-head-blk">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <div class="court-table-head">
                                                <h4>Requests</h4>
                                                <p>Efficiently manage and respond to booking requests</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="coach-active-blk">
                                                <div id="tablefilter">
                                                    <div class="dataTables_filter">
                                                        <label> 
                                                            <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="card-header-btns">
                                                    <nav>
                                                        <div class="nav nav-tabs" role="tablist">
                                                            <button class="nav-link active" id="nav-Recent-tab"
                                                                data-bs-toggle="tab" data-bs-target="#nav-Recent"
                                                                type="button" role="tab" aria-controls="nav-Recent"
                                                                aria-selected="true">Court</button>
                                                            <button class="nav-link" id="nav-RecentCoaching-tab"
                                                                data-bs-toggle="tab" data-bs-target="#nav-RecentCoaching"
                                                                type="button" role="tab" aria-controls="nav-RecentCoaching"
                                                                aria-selected="false">Coaching</button>
                                                        </div>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <coach-request-count></coach-request-count>
                                    <coach-request-coaching></coach-request-coaching>
                                </div>
                            </div>
                        </div>
                        <div class="tab-footer">
                            <div class="row">
                                <div class="col-md-6">
                                    <div id="tablelength">
                                        <div class="dataTables_length" id="DataTables_Table_0_length">
                                            <label>Show
                                                <select class="custom-select custom-select-sm form-control form-control-sm">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="-1">All</option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div id="tablepage">
                                        <div class="dataTables_paginate paging_simple_numbers"
                                            id="DataTables_Table_0_paginate">
                                            <ul class="pagination">
                                                <li class="paginate_button page-item previous disabled"
                                                    id="DataTables_Table_0_previous"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                                                        class="page-link"><i class="feather-chevrons-left"></i></a></li>
                                                <li class="paginate_button page-item active"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0"
                                                        class="page-link">1</a></li>
                                                <li class="paginate_button page-item next disabled"
                                                    id="DataTables_Table_0_next"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                                                        class="page-link"><i class="feather-chevrons-right"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- /Page Content -->


    <layout-footer></layout-footer>

    <coach-request-modal></coach-request-modal>
</template>

<script>
export default {
    data() {
        return {
            title: 'Request',
            text: 'Home',
            text1: 'Request',
            Week: ["This Week", "One Day"],
            Sort: ["Relevance", "Price"]
        }
    },
}
</script>
